/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { Box, Typography, Button } from '@mui/material';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

import {
  fetchMerchant,
  setPermitMerchantId,
} from '../../../redux/slice/merchant';
import { setSchool } from '../../../redux/slice/global';
import { getMerchantId } from '../../../redux/slice/user';

import debounce from '../../../utils/debounce';

// import CircularLoading from '../../common/CircularLoading';

const FlexDiv = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const SelectSchool = (props) => {
  const { cut } = props;
  const { t } = useTranslation('login');

  const [selected, setSelected] = useState('');

  const dispatch = useDispatch();

  const { permit_list } = useSelector((state) => state.merchant);

  const { state } = useLocation();

  // no repetition call api
  useEffect(() => {
    if (!permit_list.length) {
      dispatch(fetchMerchant());
    }
  }, []);

  // default school length to 1 automatic next page
  // other have route state no automatic
  useEffect(() => {
    if (permit_list.length === 1 && !state) {
      dispatch(setSchool(permit_list[0]));
      localStorage.setItem('merchant_id', permit_list[0].display_id);
      dispatch(getMerchantId(permit_list[0].display_id));
      dispatch(setPermitMerchantId(permit_list[0].display_id));
      cut();
    }
  }, [permit_list.length, state]);

  const clickHandle = () => {
    const school = permit_list.find((item) => item.display_id === selected);
    dispatch(setSchool(school));
    localStorage.setItem('merchant_id', school.display_id);
    dispatch(getMerchantId(school.display_id));
    dispatch(setPermitMerchantId(school.display_id));
    cut();
  };

  return (
    <Box
      sx={{
        width: { xs: '98vw', md: 820 },
        position: 'relative',
        background: '#fff',
        borderRadius: '10px',
        padding: '34px 54px 41px 54px',
        boxSizing: 'border-box',
        minHeight: '400px',
      }}
    >
      <FlexDiv>
        <Typography
          variant="body1"
          gutterBottom
          sx={{
            fontSize: '26px',
            mb: 0,
            fontWeight: '700',
          }}
        >
          {t('select_school')}
        </Typography>
      </FlexDiv>
      <Box sx={{ mt: 4 }}>
        {t('school_name')}
        <FormControl variant="standard" sx={{ m: 1, width: '100%' }}>
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={permit_list}
            getOptionLabel={(option) => option.NAME}
            onChange={(event, newValue) =>
              debounce(setSelected(newValue.display_id))
            }
            renderInput={(params) => (
              <TextField {...params} sx={{ width: '100%' }} />
            )}
          />
        </FormControl>
      </Box>
      <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 2 }}>
        <Button variant="contained" disabled={!selected} onClick={clickHandle}>
          {t('next_step')}
        </Button>
      </Stack>
    </Box>
  );
};

SelectSchool.propTypes = {
  cut: PropTypes.func.isRequired,
};

export default SelectSchool;
